import { render, staticRenderFns } from "./SupportHome.vue?vue&type=template&id=03ba30b4&"
import script from "./SupportHome.vue?vue&type=script&lang=js&"
export * from "./SupportHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports